import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  projectData: [],
  projectDetails: null,
  totalCount: 0,
  error: null,
  currentPage: 1,
  itemsPerPage: 10,
};

const ProjectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {
    fetchProjectStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchProjectSuccess(state, action) {
      state.isLoading = false;
      state.projectData = action.payload.data;
      state.totalCount = action.payload.totalCount;
      state.error = null;
    },
    fetchProjectFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    markCompletedProjectStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    markCompletedProjectSuccess(state, action) {
      state.isLoading = false;
      state.projectDetails = action.payload;
      state.error = null;
    },
    markCompletedProjectFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    fetchProjectDetailsStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchProjectDetailsSuccess(state, action) {
      state.isLoading = false;
      state.projectDetails = action.payload;
      state.error = null;
    },
    fetchProjectDetailsFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    addProjectStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    addProjectSuccess(state, action) {
      if (!Array.isArray(state.projectData)) {
        console.error("projectData is not an array, resetting to empty array");
        state.projectData = [];
      }
      state.projectData = [...state.projectData, action.payload];
      state.totalCount += 1;
      console.log("Updated projectData:", state.projectData);
    },

    addProjectFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    editProjectStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    editProjectSuccess(state, action) {
      state.isLoading = false;
      const updatedProject = action.payload;
      console.log("ediit action payload", action.payload);
      state.projectData = state?.projectData?.map((project) =>
        project.project_id === updatedProject?.project_id
          ? { ...project, ...updatedProject }
          : project
      );
    },

    editProjectFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    deleteProjectStart(state) {
      state.isLoading = true;
      state.error = null;
    },
    deleteProjectSuccess(state, action) {
      state.isLoading = false;
      state.projectDetails = action.payload;
      state.error = null;
    },
    deleteProjectFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    setCurrentPage(state, action) {
      state.currentPage = action.payload;
    },
    setItemsPerPage(state, action) {
      state.itemsPerPage = action.payload;
    },
  },
});

export const {
  addProjectSuccess,
  addProjectStart,
  addProjectFailure,
  fetchProjectStart,
  fetchProjectSuccess,
  fetchProjectFailure,
  deleteProjectStart,
  deleteProjectSuccess,
  deleteProjectFailure,
  setCurrentPage,
  setItemsPerPage,
  fetchProjectDetailsStart,
  fetchProjectDetailsSuccess,
  fetchProjectDetailsFailure,
  markCompletedProjectStart,
  markCompletedProjectSuccess,
  markCompletedProjectFailure,
  editProjectSuccess,
  editProjectStart,
  editProjectFailure,
} = ProjectSlice.actions;

export default ProjectSlice.reducer;
